const HIERARCHY_TYPES_EMBEDDED = '_embedded';
const HIERARCHY_TYPES = 'hierarchyTypes';

const HIERARCHY_TYPE = 'type';
const HIERARCHY_TYPE_DESCRIPTION = 'description';
const HIERARCHY_TYPE_ID = 'id';
const HIERARCHY_TYPE_NAME = 'name';

const HIERARCHY_NODE_ID = 'id';
const HIERARCHY_NODE_LABEL = 'label';
const HIERARCHY_NODE_NODES = 'nodes';

/** @deprecated TODO: remove this */
export class HierarchyType {
  constructor(rawData = {}) {
    this.rawData = {...rawData};
  }

  getId() {
    return this.rawData[HIERARCHY_TYPE_ID];
  }

  getRawData() {
    return this.rawData;
  }

  getDescription() {
    return this.rawData[HIERARCHY_TYPE_DESCRIPTION];
  }

  getName() {
    return this.rawData[HIERARCHY_TYPE_NAME];
  }

  getOptionsProjection() {
    return {
      value: this.getId(),
      label: this.getName(),
    };
  }
}

export class HierarchyTypes {
  static initHierarchyTypes(rawDataHierarchyTypes) {
    const hierarchyTypes = [];
    if (rawDataHierarchyTypes) {
      rawDataHierarchyTypes.forEach((hierarchyType) => {
        hierarchyTypes.push(new HierarchyType(hierarchyType));
      });
    }
    return hierarchyTypes;
  }

  constructor(rawData = {}) {
    this.rawData = {...rawData};
    this.loaded = false;
    if (this.rawData && this.rawData[HIERARCHY_TYPES_EMBEDDED]) {
      this.hierarchyTypes = HierarchyTypes.initHierarchyTypes(this.rawData[HIERARCHY_TYPES_EMBEDDED][HIERARCHY_TYPES]);
      this.loaded = true;
    }
  }

  getRawData() {
    return this.rawData;
  }

  isLoaded() {
    return this.loaded;
  }

  getItems() {
    return this.hierarchyTypes;
  }
}

export class HierarchyNodeOld {
  constructor(rawData = {}) {
    this.rawData = {...rawData};
  }

  getId() {
    return this.rawData[HIERARCHY_NODE_ID];
  }

  getRawData() {
    return this.rawData;
  }

  getLabel() {
    return this.rawData[HIERARCHY_NODE_LABEL];
  }
}

export class HierarchyNodes {
  static initHierarchyType(rawDataHierarchyType) {
    let hierarchyType;
    if (rawDataHierarchyType) {
      hierarchyType = new HierarchyType(rawDataHierarchyType);
    }
    return hierarchyType;
  }

  static initNodes(rawDataNodes) {
    const nodes = [];
    if (rawDataNodes) {
      rawDataNodes.forEach((hierarchyNode) => {
        nodes.push(new HierarchyNodeOld(hierarchyNode));
      });
    }
    return nodes;
  }

  static serializeHierarchy(hierarchy) {
    let serialized = '';
    if (hierarchy) {
      hierarchy.getNodes().forEach((node) => {
        serialized += `// ${node.getLabel()}`;
      });
    }
    return serialized;
  }

  constructor(rawData = {}) {
    this.rawData = {...rawData};
    this.hierarchyType = HierarchyNodes.initHierarchyType(this.rawData[HIERARCHY_TYPE]);
    this.nodes = HierarchyNodes.initNodes(this.rawData[HIERARCHY_NODE_NODES]);

    this.serializedHierarchy = HierarchyNodes.serializeHierarchy(this);
  }

  getId() {
    return this.rawData[HIERARCHY_NODE_ID];
  }

  getRawData() {
    return this.rawData;
  }

  getSerializedHierarchy() {
    return this.serializedHierarchy;
  }

  getTableProjection() {
    return {
      ...this.getRawData(),
      name: this.getHierarchyType() ? this.getHierarchyType().getName() : '',
      content: this.getSerializedHierarchy(),
    };
  }

  getLabel() {
    return this.rawData[HIERARCHY_NODE_LABEL];
  }

  getNodes() {
    return this.nodes;
  }

  getHierarchyType() {
    return this.hierarchyType;
  }
}

export default {HierarchyNodeOld, HierarchyNodes, HierarchyType, HierarchyTypes};
